(() => {
  const directories = new Map();

  const normalize = (value = '') => value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLocaleLowerCase('ca')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');

  const loadDirectory = async (authorsUrl) => {
    if (!directories.has(authorsUrl)) {
      const separator = authorsUrl.includes('?') ? '&' : '?';
      directories.set(authorsUrl, fetch(`${authorsUrl}${separator}view=author-links`, {
        headers: { Accept: 'text/html' }
      }).then(async (response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        return [...page.querySelectorAll('[data-author-directory-entry]')].map((entry) => ({
          url: entry.href,
          handle: entry.dataset.authorHandle || '',
          sourceHandle: entry.dataset.authorSourceHandle || '',
          nameHandle: entry.dataset.authorNameHandle || ''
        }));
      }));
    }
    return directories.get(authorsUrl);
  };

  const resolveLinks = async (scope = document) => {
    const links = [...scope.querySelectorAll('[data-author-resolve]')];
    const groups = new Map();

    links.forEach((link) => {
      const authorsUrl = link.dataset.authorsUrl;
      if (!authorsUrl) return;
      if (!groups.has(authorsUrl)) groups.set(authorsUrl, []);
      groups.get(authorsUrl).push(link);
    });

    await Promise.all([...groups].map(async ([authorsUrl, pendingLinks]) => {
      try {
        const entries = await loadDirectory(authorsUrl);
        pendingLinks.forEach((link) => {
          const requestedHandle = normalize(link.dataset.authorHandle);
          const requestedName = normalize(link.dataset.authorName);
          const match = entries.find((entry) => (
            entry.handle === requestedHandle || entry.sourceHandle === requestedHandle
          )) || entries.find((entry) => entry.nameHandle === requestedName);

          if (match) {
            link.href = match.url;
            link.removeAttribute('data-author-resolve');
          }
        });
      } catch (error) {
        // The exact bibliography URL remains as a functional fallback.
      }
    }));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => resolveLinks());
  } else {
    resolveLinks();
  }

  document.addEventListener('shopify:section:load', (event) => resolveLinks(event.target));

  window.ManifestAuthorLinks = { resolve: resolveLinks };
})();
